import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgTijd = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#60D15D"
      d="M20 34c7.732 0 14-6.268 14-14S27.732 6 20 6 6 12.268 6 20s6.268 14 14 14"
    />
    <path
      fill="#B3E9B1"
      d="M20 23a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
    />
    <path
      fill="#00215B"
      d="M22 4c8.284 0 15 6.716 15 15s-6.716 15-15 15S7 27.284 7 19h1c0 7.732 6.268 14 14 14s14-6.268 14-14S29.732 5 22 5zm0 0c8.284 0 15 6.716 15 15s-6.716 15-15 15S7 27.284 7 19h1c0 7.732 6.268 14 14 14s14-6.268 14-14S29.732 5 22 5z"
    />
    <path
      fill="#00215B"
      d="m26.32 24.616-.64.768-6.18-5.15V9h1v10.766z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgTijd);

export default ForwardRef;
